import { BLOCKING_PANEL } from '../../constants.js';

const initialActionFromSM = {
  reducer_type : BLOCKING_PANEL.Z_INDEX,
  actionType : BLOCKING_PANEL.Z_INDEX,
  zIndex : -1
};

const blockingPanelReducer = (state = initialActionFromSM, action) => {
  if(action.type === BLOCKING_PANEL.Z_INDEX){
    return { actionType: BLOCKING_PANEL.Z_INDEX, zIndex : action.zIndex };
  }
  else{
    return state;
  }
}

export default blockingPanelReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_blocking_panel.js